import React from 'react';
import { Row, Col, Skeleton } from 'antd';

export const SkeletonLoading: React.FC = () => {
  return (
    <Row justify="start">
      <Col
        span={7}
        className="chat-loading-skeleton"
        style={{ padding: '20px' }}
      >
        <Col style={{ paddingTop: '10px'}}>
          <Skeleton active avatar paragraph={{ rows: 0 }} title={false} />
        </Col>
        <Col style={{ paddingTop: '10px' }}>
          <Skeleton active paragraph={{ rows: 1 }} title={false} />
        </Col>
        <Col style={{ paddingTop: '10px' }}>
          <Skeleton active paragraph={{ rows: 1 }} title={false} />
        </Col>
      </Col>
      <Col
        span={7}
        className="chat-loading-skeleton"
        style={{ padding: '20px' }}
      >
        <Col style={{ paddingTop: '10px' }}>
          <Skeleton active avatar paragraph={{ rows: 0 }} title={false} />
        </Col>
        <Col style={{ paddingTop: '10px' }}>
          <Skeleton active paragraph={{ rows: 1 }} title={false} />
        </Col>
        <Col style={{ paddingTop: '10px' }}>
          <Skeleton active paragraph={{ rows: 1 }} title={false} />
        </Col>
      </Col>
      <Col
        span={7}
        className="chat-loading-skeleton"
        style={{ padding: '20px' }}
      >
        <Col style={{ paddingTop: '10px'}}>
          <Skeleton active avatar paragraph={{ rows: 0 }} title={false} />
        </Col>
        <Col style={{ paddingTop: '10px' }}>
          <Skeleton active paragraph={{ rows: 1 }} title={false} />
        </Col>
        <Col style={{ paddingTop: '10px' }}>
          <Skeleton active paragraph={{ rows: 1 }} title={false} />
        </Col>
      </Col>
    </Row>
  );
};
